import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CrmTranslatePipe } from 'common-module/translate';

@Component({
  selector: 'app-new-version',
  template: `
    <span>
      {{ 'crm.version.newVersionAvailable' | crmTranslate }}
      <span class="clickable-link">
        {{ 'crm.version.reloadAction' | crmTranslate }}
      </span>
    </span>
  `,
  styleUrls: ['./new-version.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CrmTranslatePipe],
})
export class NewVersionComponent {}
